import BaseModel from './BaseModel';

class EquipmentCatalogArticle extends BaseModel {}

export default EquipmentCatalogArticle;
